import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";

import { Typography, Box, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TablePagination, TableRow, TextField, TableHead } from "@material-ui/core";
import { Alert, Autocomplete } from "@material-ui/lab";

import { getError } from "../../utils/constants";
import axiosInstance from "../../utils/axios";

const rowsPerPage = 10;

function Offices() {
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(undefined);
  const [error, setError] = useState(undefined);
  const history = useHistory();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await axiosInstance.get(`/admin/offices`);
      setData(res.data);
    } catch (e) {
      console.error(e);
      setError({type: "error", open: true, message: getError(e)});
    } finally {
      setIsLoading(false);
    }
  }

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  if (isLoading) {
    return (
      <CircularProgress />
    );
  }

  if (error) {
    return (
      <Alert severity={error.type}>
        {error.message}
      </Alert>
    );
  }

  return (<>
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
      <Typography variant="caption">
        To create a new office, first <Link to="/executiveprofile">create a new executive profile</Link>
      </Typography>
      <Box width="30%">
        <Autocomplete options={data} getOptionLabel={(o) => `${o.TheSection} - ${o.Division}`} renderInput={(params) => <TextField {...params} label="Search" variant="outlined" size="small" />} onChange={(_, o) => history.push(`/office/${encodeURIComponent(o.TheSection)}/${encodeURIComponent(o.Division)}`)} />
      </Box>
    </Box>

    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Section Name</TableCell>
            <TableCell>Division Name</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
            <TableRow hover={true} component={Link} to={`/office/${encodeURIComponent(row.TheSection)}/${encodeURIComponent(row.Division)}`} key={index}>
              <TableCell>
                {row.TheSection}
              </TableCell>
              <TableCell>
                {row.Division}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              count={data.length}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[rowsPerPage]}
              page={page}
              onPageChange={handleChangePage}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  </>);
}

export default Offices;
